<template lang="pug">
  section.article
    ArticleHeader(rudo="bGFyLh")
    .spacer
      Sharer(
        :baseurl="config.baseurl", :slug="$route.path", title="La premiación", description="La ceremonia del 14avo premio al emprendedor", img="content/share.jpg", :hashtag="config.hashtag", :brandtitle="config.brandtitle", :reporttitle="config.reporttitle")

</template>
<script>
import { mapState } from 'vuex'
import ArticleHeader from '@/components/BancoEstado/ArticleHeader'
import Sharer from '@/components/Sharer'
export default {
  components: {
    ArticleHeader,
    Sharer,
  },
  computed: {
    ...mapState([
      'config'
    ]),
  },
  metaInfo() {
    return {
      title: 'Valientes Bancoestado - Especiales La Tercera',
      titleTemplate: 'La Premiación - %s',
      meta: [
        {
          vmid: 'ogtitle',
          property: 'og:title',
          content: `La Premiación - ${this.config.reporttitle} - ${this.config.brandtitle}`
        },
        {
          vmid: 'ogdescription',
          property: 'og:description',
          content: 'Desde 2005, BancoEstado ha premiado a diferentes emprendedores para potenciar sus negocios. Conoce a continuación a los ganadores, a lo largo de Chile, de esta nueva edición del Premio al Emprendedor.',
        },
        {
          vmid: 'ogurl',
          property: 'og:url',
          content: this.config.baseurl + this.$route.path
        },
        {
          vmid: 'ogimage',
          property: 'og:image',
          content: this.config.baseurl + '/content/share.jpg'
        },
        {
          vmid: 'ogsecureimage',
          property: 'og:secure:image',
          content: this.config.baseurl + '/content/share.jpg'
        }
      ]
    }
  }
}
</script>

